import type { ReactElement } from 'react';
import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';

import type { CommonProps } from './FormGroup.types';

export const Wrapper = styled.div`
  position: relative;
`;
export type Props = CommonProps & {
  className: string;
  errorDirection: string | null | undefined;
};
export const FormGroup = ({ className, children, ...other }: Props): ReactElement => (
  <Wrapper className={classNames(className, 'form-group')} {...other}>
    {children}
  </Wrapper>
);
FormGroup.defaultProps = {
  className: '',
  validationError: '',
  errorDirection: 'top',
};
export default FormGroup;
